import { useState, useMemo, useEffect } from 'react';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

export const usePaginationTable = ({ dataCount, params, getList }) => {
  const location = useLocation();
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState(params.search.page || '1');
  const pageSize = params.search.page_size || '10';

  const pagesCount = useMemo(() => Math.ceil(dataCount / Number(pageSize)), [dataCount, pageSize]);

  const currentPageParam = useMemo(() => Number(queryString.parse(location.search)?.page) || 1, [location.search]);

  useEffect(() => {
    setCurrentPage(String(currentPageParam));
  }, [currentPageParam]);

  const handlePageSizeChange = value => {
    history.replace({
      ...location,
      search: queryString.stringify({
        ...params.search,
        page: '1',
        page_size: value,
      }),
    });

    setCurrentPage('1');

    getList({
      search: { ...params.search, page: '1', page_size: value },
    });
  };

  const handlePageChange = value => {
    history.replace({
      ...location,
      search: queryString.stringify({
        ...params.search,
        page: value,
        page_size: pageSize,
      }),
    });

    setCurrentPage(value);

    getList({
      search: { ...params.search, page: value, page_size: pageSize },
    });
  };

  const applyPageChange = () => {
    if (currentPage === String(currentPageParam)) {
      return;
    }

    if (currentPage === '') {
      setCurrentPage(String(currentPageParam));
      return;
    }

    const page = Number(currentPage);

    if (page < 1 || page > pagesCount) {
      setCurrentPage(String(currentPageParam));
      return;
    }

    handlePageChange(String(page));
  };

  const handleInputChange = ({ target }) => {
    const value = target.value;

    if (value === '' || /^\d+$/.test(value)) {
      setCurrentPage(value);
    }
  };

  const handleInputBlur = () => {
    applyPageChange();
  };

  const handleInputKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyPageChange();
      e.currentTarget.blur();
    }
  };

  return {
    currentPage,
    currentPageParam,
    pageSize,
    pagesCount,
    handlePageSizeChange,
    handlePageChange,
    handleInputChange,
    handleInputBlur,
    handleInputKeyDown,
  };
};
